export default function formatNumbers(number) {
  return new Intl.NumberFormat("fr-FR").format(number);
}
